// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { slideshowStyles } from "@rpsc/Overrides/Widgets/Basic/Slideshow";
import { color } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

const arrowWrapperStyles = {};

const arrowButtonStyles = {
    css: css`
        border: 0;
        padding: 0;
    `,
};

const centeredFlexWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 5px;
    `,
};

slideshowStyles.dotButton = {
    css: css`
        outline: none;
        height: 10px;
        width: 10px;
        padding: 0;
        margin: 0 2px;
        border: 1px solid ${color("common.border")};
        border-radius: 50%;
        min-height: auto;
        background-color: transparent;
        &:focus:not(:disabled),
        &:active:not(:disabled) {
            background-color: transparent;
        }
        &:hover:not(:disabled) {
            border: 1px solid ${color("primary")};
            background-color: ${color("primary")};
        }
    `,
};

slideshowStyles.iconProps = {
    size: 10,
    css: css`
        width: 10px;
        height: 18px;
        padding-top: 14px;
        > svg {
            color: ${color("primary")};
            width: 10px;
            height: 18px;
        }
    `,
};

slideshowStyles.slideshowWrapper = {
    css: css`
        position: relative;
    `,
};

slideshowStyles.prevArrowWrapper = arrowWrapperStyles;

slideshowStyles.nextArrowWrapper = arrowWrapperStyles;

slideshowStyles.nextArrowButton = arrowButtonStyles;

slideshowStyles.prevArrowButton = arrowButtonStyles;

slideshowStyles.controlsWrapper = centeredFlexWrapper;

slideshowStyles.dotsContainerWrapper = centeredFlexWrapper;
